export let STEPS = /*#__PURE__*/function (STEPS) {
  STEPS["BEFORE_APPROVING_MOCKUP"] = "BEFORE_APPROVING_MOCKUP";
  STEPS["APPROVE_MOCKUP"] = "APPROVE_MOCKUP";
  STEPS["NOTECARD_LOGO_AND_COLOR"] = "NOTECARD_LOGO_AND_COLOR";
  STEPS["NOTECARD_TEXT_CONTENT"] = "NOTECARD_TEXT_CONTENT";
  return STEPS;
}({});
export const NOTECARD_STEPS = [STEPS.NOTECARD_LOGO_AND_COLOR, STEPS.NOTECARD_TEXT_CONTENT];